<template>
  <div>
    <button
      type="button"
      class="btn btn-white btn-adults-icon"
      data-toggle="modal"
      data-target="#adults-children-inputs"
    >{{ info }}</button>

    <button
      type="button"
      class="btn btn-white btn-children-icon"
      data-toggle="modal"
      data-target="#adults-children-inputs"
    >{{ infoChildren }}</button>

    <div class="modal fade" id="adults-children-inputs">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ info }}</h5>
          </div>
          <div class="modal-body">
            <div class="d-flex justify-content-between">
              <label for="adults" class="justify-content-start mr-1">Broj odraslih:</label>
              <input
                type="number"
                name="odrasli"
                id="adults"
                class="form-control"
                v-model.number="totalAdults"
                min="1"
                max="8"
                step="1"
                @input="handleAdults"
                @blur="checkAdults"
              />
            </div>
            <div class="d-flex justify-content-between mt-1">
              <label for="children" class="justify-content-start mr-1">Broj djece:</label>
              <input
                type="number"
                id="children"
                class="form-control"
                v-model.number="totalChildren"
                min="0"
                max="4"
                step="1"
                @input="handleChildren"
                @blur="checkChildren"
              />
            </div>
            <div class="border-top mt-2 pt-2" v-if="totalChildren > 0">
              <h6>Godine djeteta pri povratku s putovanja:</h6>
              <div
                v-for="i in totalChildren"
                :key="`child-age-index-${i}`"
                class="d-flex"
                :class="{ 'mt-1': i > 1 }"
              >
                <label v-html="`${i}. dijete:`"></label>
                <select
                  class="form-control form-control-sm ml-auto"
                  v-model="childrenAgesLocal[i-1]"
                >
                  <option v-for="k in 17" :key="k" :value="k" v-html="k"></option>
                </select>
              </div>
              <input type="hidden" name="djecaGodine" :value="getChildrenAgesAsString" />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" data-dismiss="modal">Potvrdi</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    adults: {
      required: true,
      type: Number
    },
    children: {
      required: true,
      type: Number
    },
    childrenAges: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      totalAdults: this.adults,
      totalChildren: this.children,
      childrenAgesLocal: this.childrenAges
    };
  },

  computed: {
    info() {
      let adults = this.totalAdults;

      let adultsInfo = adults > 1 ? `${adults} odraslih` : "1 odrasla osoba";

      return adultsInfo;
    },
    infoChildren() {
      let children = this.totalChildren;

      let childrenInfo = children > 1 ? `${children} djece` : "1 dijete";

      return children > 0 ? `${childrenInfo}` : "0 djece";
    },
    getChildrenAgesAsString() {
      return this.childrenAgesLocal.join();
    }
  },

  watch: {
    totalChildren(val) {
      if (val == 0) {
        this.childrenAgesLocal = [];
      } else if (this.childrenAgesLocal.length > val) {
        return this.childrenAgesLocal.splice(
          val,
          this.childrenAgesLocal.length
        );
      }
    }
  },

  methods: {
    checkAdults() {
      if (this.totalAdults > 8) {
        this.totalAdults = 8;
      } else if (this.totalAdults < 1) {
        this.totalAdults = 1;
      }
    },
    checkChildren() {
      if (this.totalChildren > 4) {
        this.totalChildren = 4;
      } else if (this.totalChildren < 0) {
        this.totalChildren = 0;
      }
    },

    handleAdults(event) {
      if (!event.data) {
        return;
      }

      if (event.data > 8) {
        this.totalAdults = 8;
      } else if (event.data < 1) {
        this.totalAdults = 1;
      }
    },
    handleChildren(event) {
      if (!event.data) {
        return;
      }

      if (event.data > 4) {
        this.totalChildren = 4;
      } else if (event.data < 0) {
        this.totalChildren = 0;
      }
    }
  }
};
</script>
